export default "__VITE_PUBLIC_ASSET__07434b9a__"